import React, {FC, memo, useEffect} from "react";
import {Form, Row} from "react-bootstrap";

import {PageProfileContainer} from "./PageProfileStyle";
import {actions} from "../../store/sliceApp";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";

const PageProfile: FC = () => {
    const {name, login, email, roles} = useSelector((state: IRootState) => state.user.user)
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(actions.clearAll())
    }, [])

    return(
        <PageProfileContainer>
            <h1>Профиль</h1>
            <Form style={{width: "100%"}}>
                <Row style={{flexDirection: "column", gap: "10px", maxWidth: "700px"}}>
                    <Form.Group as={"div"} controlId="validationCustom01">
                        <Form.Label>Имя</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            placeholder="Имя"
                            value={name}
                            // isValid={name.isValid}
                            // isInvalid={name.isInvalid}
                            // onChange={(event) => validationField(event.target.value, setName)}
                        />
                        {/*<Form.Control.Feedback type="invalid">Введите имя</Form.Control.Feedback>*/}
                    </Form.Group>

                    <Form.Group as={"div"}  controlId="validationCustom02">
                        <Form.Label>Логин</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            placeholder="Логин"
                            value={login}
                            // isValid={login.isValid}
                            // isInvalid={login.isInvalid}
                            // onChange={validationLogin}
                        />
                        {/*{!loginError && <Form.Control.Feedback type="invalid">Введите логин</Form.Control.Feedback>}*/}
                        {/*{loginError && <Form.Control.Feedback type="invalid">Пользователь с таким логином уже существует</Form.Control.Feedback>}*/}
                    </Form.Group>

                    <Form.Group as={"div"} controlId="validationCustom04" style={{marginBottom: "10px"}}>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            disabled
                            type="email"
                            placeholder="Email"
                            value={email}
                            // isValid={email.isValid}
                            // isInvalid={email.isInvalid}
                            // onChange={validationEmail}
                        />
                        {/*<Form.Control.Feedback type="invalid">Ошибка ввода email</Form.Control.Feedback>*/}

                    </Form.Group>

                    {/*<ButtonGroup >*/}
                    {/*    <Button variant="outline-primary" type={"submit"}>Зарегистрироваться</Button>*/}
                    {/*</ButtonGroup>*/}
                </Row>
            </Form>
        </PageProfileContainer>

    )
}
export default memo(PageProfile)
